import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import CarRentalPackageService from "../../services/carrentalpackage.service";

export const getcarrentalPackageList = createAsyncThunk(
  "carrentalPackage/getcarrentalPackageList",
  async (item, thunkApi) => {
    try {
      const data = await CarRentalPackageService.getcarrentalPackageList(item);
      return { carrentalpackages: data };
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkApi.rejectWithValue({ message });
    }
  }
);

export const carPackagePrice = createAsyncThunk(
  "carrentalPackage/carPackagePrice",
  async (item, thunkApi) => {
    try {
      const data = await CarRentalPackageService.carpackageprice(item);
      return { carpackageprice: data };
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkApi.rejectWithValue({ message });
    }
  }
);


export const getAirportCharges = createAsyncThunk(
  "carrentalPackage/getAirportCharges",
  async (item, thunkApi) => {
    try {
      const data = await CarRentalPackageService.getairportPrice(item);
      return { airportCharges: data };
    } catch (error) {
      const message =
        error.response?.data?.message || error.message || "Failed to fetch airport charges";
      return thunkApi.rejectWithValue({ message });
    }
  }
);

export const getHourlyCharges = createAsyncThunk(
  "carrentalPackage/getHourlyCharges",
  async (item, thunkApi) => {
    try {
      const data = await CarRentalPackageService.gethourlyPrice(item);
      return { hourlyCharges: data };
    } catch (error) {
      const message =
        error.response?.data?.message || error.message || "Failed to fetch hourly charges";
      return thunkApi.rejectWithValue({ message });
    }
  }
);

export const getPlaceWisehotel = createAsyncThunk(
  "carrentalPackage/getPlaceWisehotel",
  async (placeId, thunkApi) => {
    try {
     
     
      const data = await CarRentalPackageService.getplacewiseHotel({ place: placeId });

      return { placewiseHotel: data };
    } catch (error) {
    
      return thunkApi.rejectWithValue({ message: error.message || "Failed to fetch hotels" });
    }
  }
);

export const pickupdropprice = createAsyncThunk(
  "carrentalPackage/pickupdropprice",
  async (item, thunkApi) => {
    try {
      const data = await CarRentalPackageService.getpickupdropPrice(item);
      return { pickupdropprice: data };
    } catch (error) {
      const message =
        error.response?.data?.message || error.message || "Failed to fetch hourly charges";
      return thunkApi.rejectWithValue({ message });
    }
  }
);


const initialState = {
  loading: false,
  error: null,
  carRentalPackages: [],
  travelPackagePrice: null,
  airportCharges: null,
  hourlyCharges: null,
};

const CarRentalPackageSlice = createSlice({
  name: "carRental",
  initialState,
  extraReducers: (builder) => {
    builder
      // Fetch Car Rental Packages
      .addCase(getcarrentalPackageList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getcarrentalPackageList.fulfilled, (state, action) => {
        state.loading = false;
        state.carRentalPackages = action.payload.carRentalPackages;
      })
      .addCase(getcarrentalPackageList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Error fetching data";
      })

      // Fetch Package Price
      .addCase(carPackagePrice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(carPackagePrice.fulfilled, (state, action) => {
        state.loading = false;
        state.travelPackagePrice = action.payload.travelPackagePrice;
      })
      .addCase(carPackagePrice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Error fetching data";
      })

      // Fetch Airport Charges
      .addCase(getAirportCharges.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAirportCharges.fulfilled, (state, action) => {
        state.loading = false;
        state.airportCharges = action.payload.airportCharges;
      })
      .addCase(getAirportCharges.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Error fetching airport charges";
      })

      // Fetch Hourly Charges
      .addCase(getHourlyCharges.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getHourlyCharges.fulfilled, (state, action) => {
        state.loading = false;
        state.hourlyCharges = action.payload.hourlyCharges;
      })
      .addCase(getHourlyCharges.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Error fetching hourly charges";
      })

      .addCase(getPlaceWisehotel.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPlaceWisehotel.fulfilled, (state, action) => {
        state.loading = false;
        state.placewiseHotel = action.payload.placewiseHotel;
      })
      
      .addCase(getPlaceWisehotel.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Error fetching placewise hotel";
      })

      .addCase(pickupdropprice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(pickupdropprice.fulfilled, (state, action) => {
        state.loading = false;
        state.pickupdropprice = action.payload.pickupdropprice;
      })
      .addCase(pickupdropprice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Error fetching pickupdropprice";
      })
  },
});

export default CarRentalPackageSlice.reducer;
